import { CIQ_SDK_URL } from "src/components/ContinueDeal/constants";
import { getVehicleFinanceSettings, getVehiclesOrder } from "src/store/selectors/vehicles";
import { ApplicationStore } from "Types/state";
import { CreditAppBehavior } from "Types/api/CreditIQ";

export const getCIQIntegration = (state: ApplicationStore, vin: string) =>
    getVehicleFinanceSettings(state, vin)?.credit_iq;

export const getCIQTokenFromVin = (state: ApplicationStore, vin?: string) =>
    state.creditIQ?.tokenBundle?.[vin || state.currentDeal.vin!] ?? null;

export const hasCreditIQ = (state: ApplicationStore, vin: string) =>
    getVehicleFinanceSettings(state, vin)?.credit_iq !== undefined;

export const getCIQSdkUrl = (state: ApplicationStore, vin: string) =>
    CIQ_SDK_URL[getVehicleFinanceSettings(state, vin)?.credit_iq?.environment!];

export const hasMenuingEnabled = (state: ApplicationStore, vin: string) => !!getCIQIntegration(state, vin)?.menuing;

export const showCreditIQMenuingGarageRow = (state: ApplicationStore) =>
    getVehiclesOrder(state).some((vin) => hasMenuingEnabled(state, vin));

export const hasPreQualEnabled = (state: ApplicationStore, vin: string) => !!getCIQIntegration(state, vin)?.prequal;

export const showPreQualInGarage = (state: ApplicationStore) =>
    getVehiclesOrder(state).some((vin) => hasPreQualEnabled(state, vin));

export const hasCreditAppEnabled = (state: ApplicationStore, vin: string) =>
    getCIQIntegration(state, vin)?.credit_app_behavior === CreditAppBehavior.creditApplication ||
    (!hasCreditIQ(state, vin) && !!state.account?.integration_settings?.DI_Credit);

export const hasInstantApprovalEnabled = (state: ApplicationStore, vin: string) =>
    getCIQIntegration(state, vin)?.credit_app_behavior === CreditAppBehavior.instantApproval;
